import { LatLngTuple } from 'leaflet'

import {
  Marker,
  Circle,
  CircleProps,
  Tooltip
} from 'react-leaflet'

import { SisetuMapPoint } from '../types'
import { calcRadius, dummyPin } from '../util'
import { SisetuPopup } from 'features/sisetu/map/components/sisetuPopup'

type ScoreMarkerProps = {
	point: SisetuMapPoint
	score?: number
	onOpen: (sisetuCode: string) => void
	onClose: () => void
} & Omit<CircleProps, 'center' | 'radius'>

export const ScoreMarker = ({
	point,
	score,
	onOpen,
	onClose,
	...others
}: ScoreMarkerProps) => {
  const radius = calcRadius(score)
  if (!radius) return <></>

  if (point.sisetuList.length === 1) {
    const sisetu = point.sisetuList[0]
    if (!sisetu.location) return <></>
    const position = [
      sisetu.location.latitude,
      sisetu.location.longitude,
    ] as LatLngTuple
    return (
      <Marker
        position={position}
        zIndexOffset={2}
        icon={dummyPin()}
        opacity={0}
      >
        <Circle center={position} radius={radius} {...others} />

        <Tooltip
          direction="top"
          className="tooltip"
          offset={[0, -20]}
          opacity={1}
        >
          {sisetu.sisetuName}
        </Tooltip>

        <SisetuPopup
          sisetuList={point.sisetuList}
          onOpen={onOpen}
          onClose={onClose}
        />
      </Marker>
    )
  } else {
    return (
      <Marker
        position={point.position}
        zIndexOffset={2}
        icon={dummyPin()}
        opacity={0}
        autoPan
      >
        <Circle center={point.position} radius={radius} {...others} />

        <Tooltip
          direction="top"
          className="tooltip"
          offset={[0, -20]}
          opacity={1}
        >
          {point.sisetuList.length}施設
        </Tooltip>

        <SisetuPopup
          sisetuList={point.sisetuList}
          onOpen={onOpen}
          onClose={onClose}
        />
      </Marker>
    )
  }
}